import { useState } from "react";

const ModalDelete = ({
	isOpen,
	closeModal,
	handleDelete,
	siteName = "",
	unitName = "",
	nickname = "",
	name = "",
	email = "",
	role = "",
	accName = "",
	id,
	response_message = "",
	response_error_message = "",
	hasRelations = false,
	alertBeforeDelete = "",
	hasUsersRelations = false,
	alertUsersBeforeDelete = "",
}) => {
	if (!isOpen) return null;

	const [isDeleting, setIsDeleting] = useState(false);
	const [deleteSuccess, setDeleteSuccess] = useState(false);
	const [deleteError, setDeleteError] = useState(false);
	const [successMessage, setSuccessMessage] = useState(response_message);
	const [errorMessage, setErrorMessage] = useState(response_error_message);

	const handleDeleteClick = async () => {
		setIsDeleting(true);

		try {
			const success = await handleDelete(id);
			if (success) {
				setSuccessMessage("has been deleted successfully!");
				setDeleteSuccess(true);
			}
		} catch (error) {
			setErrorMessage(error.message);
			setDeleteError(true);
		} finally {
			setIsDeleting(false);
		}
	};

	return (
		<div
			id="deleteModal"
			tabIndex="-1"
			className="fixed top-0 right-0 left-0 z-50 flex h-[calc(100%-1rem)] max-h-full w-full items-center justify-center overflow-y-auto overflow-x-hidden bg-dark-blue bg-opacity-75 p-4 md:inset-0"
		>
			<div className="relative max-h-full w-full max-w-md">
				<div className="relative rounded-lg bg-navbar-bg shadow">
					<button
						type="button"
						className="absolute top-3 right-2.5 ml-auto inline-flex items-center rounded-lg bg-transparent p-1.5 text-gray-400 text-sm hover:bg-gray-600 hover:text-white dark:hover:bg-gray-800 dark:hover:text-white"
						onClick={closeModal}
					>
						<svg
							className="h-5 w-5"
							fill="currentColor"
							viewBox="0 0 20 20"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fillRule="evenodd"
								d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
								clipRule="evenodd"
							/>
						</svg>
						<span className="sr-only">Close modal</span>
					</button>
					<div className="p-6 text-center md:p-8">
						<span className="mt-2 mb-4 break-words font-medium text-gray-400 text-sm leading-relaxed md:mb-6 md:text-lg lg:text-lg">
							Are you sure you want to delete
							<span className="font-semibold text-gray-400">
								{" "}
								{siteName} {unitName} {name} {nickname} {email} {role} {accName} ?
							</span>
						</span>
						{hasRelations && (
							<span className="mb-2 flex break-words rounded font-semibold text-sm text-yellow-600 leading-relaxed">
								{alertBeforeDelete}
							</span>
						)}

						{hasUsersRelations && (
							<span className="mb-2 flex break-words rounded font-semibold text-sm text-yellow-600 leading-relaxed">
								{alertUsersBeforeDelete}
							</span>
						)}
						<p className="mb-4 break-words text-custom-green text-sm leading-relaxed md:mb-6 md:text-sm lg:text-sm">
							{successMessage != "" &&
								`${siteName} ${unitName} ${name}  ${nickname} ${email} ${role} ${accName} ${" "} ${successMessage}`}
						</p>
						<p className="mb-5 text-red-500 text-sm">{errorMessage != "" && `${errorMessage}`}</p>
						<div>
							<button
								type="button"
								className="mr-2 inline-flex items-center rounded-lg bg-red-600 px-5 py-2.5 text-center font-medium text-sm text-white hover:bg-red-800 focus:outline-none focus:ring-4 focus:ring-red-300 dark:focus:ring-red-800"
								onClick={handleDeleteClick}
								disabled={isDeleting || deleteSuccess || deleteError}
							>
								{isDeleting ? "Deleting..." : "Yes, I'm sure"}
							</button>
							<button
								type="button"
								className="rounded-lg border-gray-600 bg-gray-200 px-5 py-2.5 font-medium text-blue-gray text-sm hover:bg-white hover:text-dark-blue focus:z-10 focus:outline-none focus:ring-4 focus:ring-gray-200"
								onClick={closeModal}
							>
								No, cancel
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ModalDelete;
